var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('label',{staticClass:"ts-mb-0"},[_vm._v(_vm._s(_vm.$t('productProfile.location')))]),_c('a-select',{staticClass:"ts-w-full",attrs:{"mode":"multiple","maxTagCount":10,"options":_vm.locationList,"showSearch":"","filterOption":(input, option) =>
            option.componentOptions.children[0].text
              .toLowerCase()
              .indexOf(input.toLowerCase()) >= 0},model:{value:(_vm.model.location),callback:function ($$v) {_vm.$set(_vm.model, "location", $$v)},expression:"model.location"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }